export async function copyTextToClipboard(text) {
	try {
		if (navigator.clipboard?.writeText) {
			await navigator.clipboard.writeText(text)
			return true
		}
	} catch (error) {
		// Fall through to the document-based strategy for restricted contexts.
	}

	let textarea = null

	try {
		textarea = document.createElement('textarea')
		textarea.value = text
		textarea.setAttribute('readonly', '')
		textarea.setAttribute('data-clipboard-fallback', '')
		textarea.style.position = 'fixed'
		textarea.style.opacity = '0'
		document.body.appendChild(textarea)
		textarea.select()

		return document.execCommand('copy')
	} catch (error) {
		return false
	} finally {
		textarea?.parentNode?.removeChild(textarea)
	}
}
